import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { CreateLessonData, Lesson, UpdateLessonData } from "./types";

export * from "./types";

/** Darslar API — backend'dagi `LessonsController` ning ko'zgusi. */
export class LessonsApi extends BaseApi {
  private readonly baseUrl: string = "/lessons";

  /** Bo'limning barcha darslari, tartiblangan holda. */
  getBySection(sectionId: number) {
    return this.request.get<Lesson[], ApiResponse<Lesson[]>>(this.baseUrl, {
      params: { sectionId },
    });
  }

  getById(id: number) {
    return this.request.get<Lesson, ApiResponse<Lesson>>(`${this.baseUrl}/${id}`);
  }

  create(data: CreateLessonData) {
    return this.request.post<Lesson, ApiResponse<Lesson>>(this.baseUrl, data);
  }

  update(id: number, data: UpdateLessonData) {
    return this.request.patch<Lesson, ApiResponse<Lesson>>(`${this.baseUrl}/${id}`, data);
  }

  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }

  /** Bo'lim ichidagi yangi tartib — TO'LIQ birodarlar ro'yxati bilan. */
  reorder(lessonIds: number[]) {
    return this.request.patch<Lesson[], ApiResponse<Lesson[]>>(`${this.baseUrl}/reorder`, {
      lessonIds,
    });
  }

  togglePublish(id: number) {
    return this.request.patch<Lesson, ApiResponse<Lesson>>(`${this.baseUrl}/${id}/toggle-publish`);
  }

  duplicate(id: number) {
    return this.request.post<Lesson, ApiResponse<Lesson>>(`${this.baseUrl}/${id}/duplicate`);
  }
}

export const lessonsApi = new LessonsApi();
